import { css } from 'aphrodite';
import { useSupportMailboxQuery } from '../../../queries/Support/useSupportMailboxQuery';
import { LoadingSpinner } from '../../../web/components/LoadingSpinner';
import { settingsStyles as st } from './styles/settingsStyles';
import { teamTabStyles as styles } from './styles/teamTabStyles';
import { TeamTabMailboxPermissionsSection } from './TeamTabMailboxPermissionsSection';
import { TeamTabRoutingSection } from './TeamTabRoutingSection';
import { TeamTabTeammatesSection } from './TeamTabTeammatesSection';

interface ITeamTabProps {
	mailboxId: string;
}

export function TeamTab({ mailboxId }: ITeamTabProps) {
	const { data: mailbox, isLoading, isError } = useSupportMailboxQuery(mailboxId);

	if (isLoading) return <LoadingSpinner />;
	if (isError) return <div className={css(st.error)}>Failed to load team settings.</div>;
	if (!mailbox) return null;

	return (
		<div className={css(styles.container)}>
			<h2 className={css(st.sectionTitle)}>Team &amp; Routing</h2>
			<div className={css(st.sectionDescription)}>Who staffs this mailbox and how new tickets get assigned.</div>
			<div className={css(st.card, styles.card)}>
				<TeamTabRoutingSection mailbox={mailbox} mailboxId={mailboxId} />
			</div>
			<div className={css(st.card)}>
				<TeamTabMailboxPermissionsSection mailbox={mailbox} />
			</div>
			<div className={css(st.card)}>
				<TeamTabTeammatesSection mailboxId={mailboxId} />
			</div>
		</div>
	);
}
